module.exports = __webpack_public_path__ + "2208f79f4e668a9743fa7f62133de251.png";